/**
 * Display-label overrides for the field picker's metadata catalog.
 *
 * The List Configuration field picker offers every native column of a list's
 * objects straight from the tenant's `_object_field` catalog (PD-14229). A few
 * of those catalog labels collide confusingly with curated picker entries —
 * e.g. the client column `revenueTrend90` is labelled "Revenue Trend 90" in
 * the catalog while the curated `rollingRevenueTrend90` pick is "Revenue 90
 * Day Trend (%)", and the two are different metrics (regression slope vs
 * percentage change; PD-13536).
 *
 * Entries here override ONLY what the picker displays. The `_object_field`
 * rows are untouched (SM1 shares their labels), and columns already used by
 * saved layouts keep working under whichever label they were stored with.
 */
export const PICKER_METADATA_LABEL_OVERRIDES: Record<
	string,
	Record<string, string>
> = {
	client: {
		// Regression-slope trend columns (line-of-best-fit steepness, unbounded
		// magnitude) — labelled so they can't be mistaken for the curated
		// percentage-change pair.
		revenueTrend90: 'Revenue Trend 90 (slope)',
		revenueTrend360: 'Revenue Trend 360 (slope)',
		revenueTrendDiff90: 'Revenue Trend Diff 90 (slope)',
		revenueTrendDiff360: 'Revenue Trend Diff 360 (slope)',
	},
};

/**
 * The catalog label the picker should show for `objectTable.fieldName` —
 * the override when one exists, otherwise the label passed in.
 */
export function resolvePickerMetadataLabel(
	objectTable: string,
	fieldName: string,
	catalogLabel: string,
): string {
	return (
		PICKER_METADATA_LABEL_OVERRIDES[objectTable]?.[fieldName] ?? catalogLabel
	);
}
